import { useMutation } from "@tanstack/react-query"
import { postRequest } from "../helpers/fetchHandler"

type FeedbackData = {
  name: string | null
  email: string | null
  phone: string | null
  feedback: string
  subject: string
  waitingReply: boolean
  destination: string | null
  appVersion: string
}

export function usePostFeedback() {
  return useMutation({
    mutationFn: (data: FeedbackData) => postRequest({ url: "/api/v1/feedback/", data, auth: true })
  })
}
